import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

/**
 * A directive to change the height of a textarea element
 * based on the amount of user input.
 */

@Directive({
	selector: '[autoExpand]'
})
export class AutoExpandDirective {
	constructor(private el: ElementRef, private renderer: Renderer2) { }

	@HostListener('input') onInput(): void {
		this.adjustHeight();
	}

	private adjustHeight(): void {
		const textarea = this.el.nativeElement as HTMLTextAreaElement;
		this.renderer.setStyle(textarea, 'height', 'auto');
		this.renderer.setStyle(textarea, 'height', `${textarea.scrollHeight}px`);
	}
}
